import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
export default {
  // state相当于一个内存，存储数据的，但是不能直接操作satate里面的数据，
  // 需要mutations 来操作state里面存储的数据
  state: {
    // 当前激活的选项卡
    editableTabsValue: 'dataHome',
    // tabs选项卡数据
    tabs: [
      {
        title: '信息看板',
        name: 'dataHome'
      }
    ],
    // 左侧菜单数据
    menu_data: []
  },
  mutations: {
    // 菜单点击时候调用
    selectMenu (state, val) {
      // 1.把当前点击的菜单对象，加到tabs里面
      let res = state.tabs.findIndex(item => item.name === val.name)
      // 2.判断tabs是否存在，不存在才加入到tabs
      if (res === -1) {
        let obj = {}
        obj.title = val.label
        obj.name = val.name
        state.tabs.push(obj)
      }
      // 设置当前选中对象
      state.editableTabsValue = val.name
      // 设置当前打开的选项卡
      sessionStorage.setItem('tabList', JSON.stringify(state.tabs))
    },
    // 设置当前选中选项卡
    getTabs (state) {
      const tabs = sessionStorage.getItem('tabList')
      state.tabs = tabs ? JSON.parse(tabs) : [{title: '信息看板', name: 'dataHome'}]
    },
    // 设置当前激活的选项卡
    setActiveTabs (state, val) {
      state.editableTabsValue = val
    },
    getMenuList (state, router) {
      // 1.取出菜单数据
      let menuList = sessionStorage.getItem('menuList')
      // 2.设置菜单数据
      if (menuList) {
        state.menu_data = JSON.parse(menuList)
      }
      // 3.取出路由数据
      let oldrouterList = sessionStorage.getItem('routerList')
      let routerList = []
      if (oldrouterList) {
        routerList = JSON.parse(oldrouterList)
      }
      // 4.动态的生成路由
      // 4.1获取原来的路由
      let oldRouter = router.options.routes
      // 遍历后台返回的路由数据，动态生成路由
      // component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
      routerList.forEach(item => {
        item.component = () => import(`@/views${item.url}.vue`)
        oldRouter[2].children.push(item)
      })
      // 5.添加到现有路由里面
      router.addRoutes(oldRouter)
    },
    // 设置收缩菜单属性
    setOpenOrClose (state) {
      state.isCollapse = !state.isCollapse
    }
  },
  actions: {
  }

}



// WEBPACK FOOTER //
// ./src/store/store.js